import React, { useState } from "react";
import parse from "html-react-parser";
import { useSelector } from "react-redux";
import Modal from "antd/lib/modal/Modal";
import { Table } from "antd";

import { ContentNoData } from "@components";
import {
  formatDate,
  i18,
  translationGroups,
  trb,
  checkIsBase64String,
  downloadFile,
  b64DecodeUnicode
} from "@utilities";
import PdfDocView from "@components/PdfDocument/PdfDocView";
import { selectApplicationDocuments, selectCurrentApplication } from "@redux/Selectors";

import "./DocumentsTable.less";

const VIEWABLE_FORMATS = [".pdf", ".jpg", ".png", ".jpeg"];

export const DocumentsTable = React.memo(() => {
  const documents = useSelector(selectApplicationDocuments);
  const application = useSelector(selectCurrentApplication);
  const [selectedDocId, setSelectedDocId] = useState();

  if (documents.length === 0) {
    return <ContentNoData />;
  }

  const columns = [
    {
      title: trb(i18.ApplicationsLabels.Datetime),
      dataIndex: "date",
      key: "date",
      render: item => formatDate(item),
      width: "10%"
    },
    {
      title: trb(i18.ApplicationsLabels.DocumentType),
      dataIndex: "type",
      key: "type",
      render: item => trb(translationGroups.DocumentType + item),
      width: "20%"
    },
    {
      title: trb(i18.ApplicationsLabels.Comment),
      dataIndex: "comment",
      key: "comment",
      className: "comment-column",
      render: item => {
        if (!item) return "";
        if (checkIsBase64String(item)) {
          const decodedHTML = b64DecodeUnicode(item);
          return parse(decodedHTML);
        }
        return item;
      },
      width: "20%"
    },
    {
      title: trb(i18.ApplicationsLabels.UploadDocComment),
      dataIndex: "documentComment",
      key: "documentComment",
      width: "20%"
    },
    {
      title: trb(i18.ApplicationsLabels.DocumentClientComment),
      dataIndex: "clientComment",
      key: "clientComment",
      width: "20%"
    }
  ];

  const handleRowClick = (e, record) => {
    if (e.target.tagName === "A") return;
    if (!record.fileExtension || VIEWABLE_FORMATS.includes(record.fileExtension.toLowerCase())) {
      setSelectedDocId(record.id);
      return;
    }

    const fileName = `${record.type}_${record.id}_${application.clientCode}_${application.clientName}${record.fileExtension}`;
    downloadFile({
      fileId: record.id,
      url: `${process.env.REACT_APP_API}Document/Get`,
      fileName
    });
  };

  return (
    <>
      <Table
        className="w-100 app-documents-table"
        dataSource={documents}
        columns={columns}
        scroll={{ x: "60vw" }}
        pagination={false}
        rowKey="id"
        rowClassName="pointer-cursor"
        onRow={record => {
          return {
            onClick: e => handleRowClick(e, record)
          };
        }}
      />
      {!!selectedDocId && (
        <Modal
          visible={!!selectedDocId}
          onCancel={() => setSelectedDocId(undefined)}
          closable={false}
          width="100%"
          footer={null}
        >
          <PdfDocView documentId={selectedDocId} showButtons={false} />
        </Modal>
      )}
    </>
  );
});
